import React, {useEffect, useState} from 'react';
import styles from './PatientCard.module.scss';
import {TBody} from "../../../common/TActions/TBody";
import {PaginationBottom} from "../../../common/PaginationBottom/PaginationBottom";
import {filterDate, searchOptions, tableTitle} from "./data";
import {useNavigate, useParams} from "react-router-dom";
import {TSort} from "../../../common/TSort/TSort";
import {patientService} from "../../../../api/patientServices";
import {DirectionService} from "../../../../api/directionService"; // Компонент для отображения строк таблицы

const PatientCard = () => {
    const navigate = useNavigate(); // Hook to navigate programmatically
    const [data, setData] = useState([]); // State to hold directions data
    const [patientData, setPatientData] = useState([]); // Patient data
    const {id} = useParams();

    const [searchTerm, setSearchTerm] = useState(''); // State for the search term
    const [perPage, setPerPage] = useState(10); // State for items per page
    const [limit, setLimit] = useState(0); // Total number of items
    const [currentPage, setCurrentPage] = useState(1); // Current page number
    const [action, setAction] = useState(0); // Delete

    // State for holding filters used in fetching data
    const [filters, setFilters] = useState({
        id: '',
        patientId: '',
        patientLastName: '',
        patientFirstName: '',
        patientMiddleName: '',
        patientAge: '',
        patientGender: '',
        department: '',
        date: '',
        status: '',
        offset: 0,
        limit: 10,
        sortBy: 'id', // Default sorting by id
    });


    // Handle filter change and reset pagination
    const handleFilterChange = (e) => {
        const {name, value} = e.target;
        setFilters({
            ...filters,
            [name]: value,
            offset: 0, // Reset pagination when filter changes
        });
        setCurrentPage(1);
    };

    // Unified useEffect for filtering, sorting, and pagination
    useEffect(() => {
        const getData = async() => {
            // Filter out empty filters
            const nonEmptyFilters = Object.fromEntries(
                Object.entries(filters).filter(([key, value]) => value !== '')
            );

            const queryParams = new URLSearchParams(nonEmptyFilters).toString(); // Prepare query params for URL
            const options = await DirectionService.getOptions().then(res => {
                if (res?.data) return res?.data
            });

            // Fetch directions based on filters
            patientService.getInfoByPatient(id, queryParams).then(res => {
                if (res?.data){
                    function getNameById(id, list){
                        const item = list.find(el => el.id === id);
                        return item ? item.name : null;
                    }

                    const result = res?.data?.data.map(({
                        hospitalId,
                        departmentId,
                        ...rest
                    }) => {
                        const hospitalName = getNameById(hospitalId, options.hospitals);
                        const departmentName = getNameById(departmentId, options.departments);
                        const outside = rest?.outside ? 'Так' : "Ні";

                        return {
                            ...rest,
                            hospitalName,
                            departmentName,
                            outside
                        };
                    });

                    setData(result); // Set directions data
                    setLimit(res?.data?.count); // Set total count of results
                    navigate(`?${queryParams}`); // Update URL with filter parameters
                }
            });
        }

        getData()
    }, [filters, navigate, action]);

    // Handle change in the number of items per page
    const handleLimitChange = (e) => {
        const newPerPage = e.target.value;
        setFilters((prevFilters) => ({
            ...prevFilters,
            limit: newPerPage, // Update limit in filters
            offset: 0, // Reset pagination on limit change
        }));
        setPerPage(newPerPage);
        setCurrentPage(1); // Reset to first page
    };

    // Sort directions based on the selected field
    const sortByFilter = (sortField) => {
        setFilters((prevFilters) => ({
            ...prevFilters,
            sortBy: sortField, // Update sort field
            offset: 0, // Reset pagination on sorting
        }));

        setCurrentPage(1); // Reset to first page
    };

    // Handle page change for pagination
    const handlePaginationChange = (pageNum) => {
        const offset = pageNum * perPage; // Calculate offset based on page number
        setFilters((prevFilters) => ({
            ...prevFilters,
            offset: offset, // Update offset in filters
        }));
        setCurrentPage(pageNum + 1); // Update current page
    };

    useEffect(() => {
        patientService.getPatientInfo(id).then(res => {
            if (res?.data){
                setPatientData(res?.data); // Set directions data
            }
        });
    }, [])

    return (
        <div className={styles['patient-card__container']}>
            <div className={styles['patient-card__wrapper']}>
                <div className={styles['patient-card']}>
                    <h2>Основна інформація пацієнта</h2>
                    <div className={styles['patient-info__wrapper']}>
                        <div className={styles['patient-info']}>
                            <div>Ім’я: {patientData.name}</div>
                            <div>Прізвище: {patientData.lastName}</div>
                            <div>По батькові: {patientData.middleName}</div>
                            <div>Стать: {patientData.gender === 'male' ? 'Чоловік' : "Жінка"}</div>
                            <div>ID: {patientData.patientNumber}</div>
                            <div>{patientData?.phoneNumber && `Номер телефону: ${patientData.phoneNumber}`}</div>
                        </div>
                        <div className={styles['patient-qrCode']}>
                            <div className={styles['patient-qrCode__id']}>{}</div>
                            <div className={styles['patient-qrCode__icon']}>{}</div>
                        </div>
                    </div>
                </div>
            </div>


            <div style={{width: '100%'}}>
                <h3>Список заключень</h3>
                <TSort
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                    setSortField={sortByFilter}
                    perPage={perPage}
                    handleLimitChange={handleLimitChange}
                    navigateUrl={'/FindPatientForm'}
                    searchOptions={searchOptions}
                />
            </div>
            <div className={styles['table-wrapper']}>
                <table className={styles['conclusions-table']}>
                    <thead>
                    <tr>{tableTitle.map((header, index) => <th key={index}>{header}</th>)}</tr>
                    <tr>
                        {filterDate.map(({name, placeholder, type = 'text', options}, index) => (
                            <th key={index}>
                                {type == 'select' ? (
                                    <select name={name} value={filters[name]} onChange={handleFilterChange}>
                                        {options.map((option, optIndex) => (
                                            <option key={optIndex}
                                                    value={option?.value}>{option?.name}</option>
                                        ))}
                                    </select>
                                ) : (
                                    <input
                                        type={type}
                                        name={name}
                                        value={filters[name]}
                                        onChange={handleFilterChange}
                                        placeholder={placeholder}
                                    />
                                )}
                            </th>
                        ))}
                    </tr>
                    </thead>

                    {/* Table body to display filtered directions data */}
                    <TBody paginatedInfo={data?.map(({
                        cassettes, hospital, department, createdAt, updatedAt, directions,
                        labFormId, patientId, docFormId, laboratoryForm, contractId, externalDepartmentId, finishedDate,
                        patient, antibodies, doctorForm, ageYears, externalDepartment, ageMonths, ageDays, ...rest
                    }) => rest)}
                           navigateUrl={'/WorkerInfo'} setAction={setAction} deleteUrl={'direction/manage'}
                           handleUrl={'EditUser'} activeActions={false} activeRead={false} activeEdit={false} activeDelete={false}/>
                </table>
            </div>

            {/* Pagination component */}
            <PaginationBottom limit={limit} perPage={perPage} currentPage={currentPage} setCurrentPage={handlePaginationChange}/>
        </div>
    );
};

export default PatientCard;